import { render, staticRenderFns } from "./app-widget-group-list.vue?vue&type=template&id=821e69fc&"
import script from "./app-widget-group-list.vue?vue&type=script&lang=js&"
export * from "./app-widget-group-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports